import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ApiUrl } from 'Services/Services';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { FaEye } from "react-icons/fa6";


import { Navigate, useNavigate } from 'react-router-dom';
import Organization from '../Organization/Organization';

function Branches() {
    const [branches, setBranches] = useState([]);
    const [organizationId, setOrganizationId] = useState();


    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    //      const FetchOrganizationId = async () =>{

    //     // setOrganizationId(JSON.parse(id));

    //   }

    useEffect(() => {
        // FetchOrganizationId();
        fetchBranches();
    }, []);

    const fetchBranches = async () => {
        try {
            const id = localStorage.getItem('organizationId');
            console.log(id);

            const payload = {
                organizationId: JSON.parse(id)
            }
            const response = await axios.put(`${ApiUrl}/branches`, payload)
            setBranches(response.data.data)
            console.log(response);
        } catch (error) {
            console.error('Error fetching branches:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (branchId) => {
        try {
            const response = await axios.delete(`${ApiUrl}/branches/${branchId}`);
            console.log(response);
            fetchBranches();
        } catch (error) {
            console.log(error)
        }
    }

    const handelView = async (id) => {
        navigate(`/admin/viewBranch/${id}`)
    }
    const handleEdit = async (id) => {
        navigate(`/admin/editBranch/${id}`)
    }

    return (
        <div className="p-6">
            {/* <h2 className="text-2xl font-bold mb-4">Restaurant Branches</h2> */}
            <div className="flex justify-end items-center mb-6">
                <button
                    onClick={() => navigate("/admin/addBranch")}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                    + Add Branch
                </button>
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <div className="overflow-x-auto rounded-xl ">
                    <table className="min-w-full border border-gray-200 bg-white shadow-md rounded-xl">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2 text-left border-b w-5">#</th>
                                <th className="px-4 py-2 text-left border-b">Name</th>
                                <th className="px-4 py-2 text-left border-b w-72">Address</th>
                                <th className="px-4 py-2 text-left border-b">Phone</th>
                                <th className="px-4 py-2  border-b text-right">Radius (km)</th>
                                <th className="px-4 py-2  border-b text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {branches.map((branch, index) => (
                                <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border-b h-7">{index + 1}</td>
                                    <td className="px-4 py-2 border-b h-7">{branch.name}</td>
                                    <td className="px-4 py-2 border-b">{branch.address}</td>
                                    <td className="px-4 py-2 border-b">{branch.phoneNumber}</td>
                                    <td className="px-4 py-2 border-b text-right">{branch.radius}</td>
                                    <td className="px-4 py-3 border-b text-right space-x-2">
                                        <button
                                            onClick={() => handelView(branch.id)}
                                            className="text-blue-500 hover:text-blue-700"
                                        >
                                            <FaEye />
                                        </button>
                                        <button
                                            onClick={() => handleEdit(branch.id)}
                                            className="text-blue-500 hover:text-blue-700"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(branch.id)}
                                            className="text-red-500 hover:text-red-700"
                                        >
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default Branches;
